import { Pipe, PipeTransform } from '@angular/core';
import { digger } from '@cbre/digger';

@Pipe({
  name: 'pickDataFrom',
  standalone: false,
})
export class PickPipe implements PipeTransform {
  transform(data: unknown, path: string): unknown | unknown[] {
    if (path == null) {
      return null;
    }

    if (Array.isArray(data)) {
      return data.map(record => digger(record, path)).filter(Boolean);
    }

    if (data != null) {
      return digger(data, path);
    }

    return null;
  }
}
